import React from 'react'
import { Tabs as ChakraTabs } from '@chakra-ui/react'
import { As, HubStyleObject, forwardRef } from '@hub/design-system-base'
import { HubTabsVariants } from './'

interface TabsProps {
  sx?: HubStyleObject
  as?: As
  variant?: HubTabsVariants
  defaultIndex?: React.ComponentProps<typeof ChakraTabs>['defaultIndex']
}

export const Tabs = forwardRef<TabsProps, typeof ChakraTabs>(
  ({ sx, as, variant = 'line', defaultIndex, children }, ref) => (
    <ChakraTabs
      ref={ref}
      sx={sx}
      as={as}
      variant={variant}
      defaultIndex={defaultIndex}
    >
      {children}
    </ChakraTabs>
  )
)
